import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteContaPagar } from '../service';
import {
  DELETE_CONTA_PAGAR,
  DELETE_CONTA_PAGAR_PENDING,
  DELETE_CONTA_PAGAR_SUCCESS,
  DELETE_CONTA_PAGAR_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteContaPagar(action) {
  yield put({ type: DELETE_CONTA_PAGAR_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.CONTA_PAGAR_EXCLUIR);

  try {
    const a = yield call(deleteContaPagar, action.id);

    if (a.status !== 204) {
      // Lança o erro original para preservar a resposta do backend
      throw a;
    }
    yield put({ type: DELETE_CONTA_PAGAR_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_CONTA_PAGAR_FAILURE });

    // Verifica se é o erro específico de OFX (status 409)
    // O erro pode vir em diferentes estruturas dependendo de como o httpService retorna
    const errorMessage = error?.response?.data?.message || error?.data?.message;
    const errorStatus = error?.response?.status || error?.status;

    if (errorStatus === 409 && errorMessage && errorMessage.includes('conciliada com transação bancária (OFX)')) {
      AlertWarning(errorMessage);
    } else {
      AlertError('Falha ao excluir o registro! Verifique se a conta não possui vínculo com outra conta gerencial ou em lançamentos no financeiro.');
    }
  }
}

export default function* watchDeleteContaPagar() {
  yield takeLatest(DELETE_CONTA_PAGAR, sagaDeleteContaPagar)
}
